<template>
  <main>
    <div class="grid-container">
      <NuxtPage />
    </div>
    <PopUp v-if="PopUp" ref="popUpRef" :mediacontent="mediacontent" />
  </main>
</template>

<script setup>
import { defineAsyncComponent } from 'vue';
import { loadTagLibrary } from '@vue-util/tagManager';
import { headLinks } from '#utils/headLinks.js';
import handlePopUpLink from '@/utils/handlePopUpLink';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PopUp = defineAsyncComponent(() => import('@nuxt-common/canvas-aem/app/components/popUp/PopUp'));

const localsStore = useLocalsStore();
const envPropsStore = useEnvPropsStore();
const popUpRef = ref(null);
const mediacontent = ref({});

useHead(() => ({
  link: headLinks,
}));

const toggle = (id) => {
  popUpRef.value.toggleModal(id);
};

const onHomePageClick = (e) => {
  const link = e.target.closest('a[href*="popupOverlayId"], area[href*="popupOverlayId"]');
  if (!link) return;
  const popUpLinkHandler = handlePopUpLink(mediacontent, toggle);
  popUpLinkHandler({
    preventDefault: () => e.preventDefault(),
    target: {
      href: link.getAttribute('href'),
      text: link.text,
      textContent: link.textContent,
      setAttribute: link.setAttribute.bind(link),
    },
  });
};

onMounted(async () => {
  document.addEventListener('click', onHomePageClick, true);
  loadTagLibrary(envPropsStore.envProps.entryPoint, envPropsStore.envProps.tagMngrEnv, true);

  const experimentation = await import('@vue-util/experimentation');
  const { ExperimentationTags } = experimentation;

  await ExperimentationTags.fireAdobeTags();
});

onUnmounted(() => {
  document.removeEventListener('click', onHomePageClick, true);
});

useHead(() => {
  const locals = localsStore.data || {};

  const meta = [
    ...(!locals.index ? [{ name: 'robots', content: 'noindex, nofollow' }] : []),
    ...(locals.description && locals.index ? [{ name: 'description', content: locals.description }] : []),
  ];

  let canonicalHref = locals.link;
  if (canonicalHref) {
    try {
      const parsedUrl = new URL(canonicalHref);
      if (envPropsStore.envProps?.siteDomain) {
        parsedUrl.hostname = new URL(envPropsStore.envProps.siteDomain).hostname;
      }
      parsedUrl.port = '';
      canonicalHref = parsedUrl.toString();
    } catch {
      console.warn('Issue while constructing canonicalHref domain url');
    }
  }

  const link = [...(canonicalHref ? [{ rel: 'canonical', href: canonicalHref }] : [])];

  return {
    title: locals.title,
    meta,
    link,
  };
});
</script>
<style lang="scss">
@media print {
  * {
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  @page {
    margin: 0mm;
    size: A3;
  }
}
</style>
